import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';
import {
  HEADER_OFFSET_SEARCH,
  MOBILE_HEADER_OFFSET,
} from 'src/constants/header';
import {
  getSearchProgress,
  isSearchCompleteSelector,
} from '../searchStatus/selectors';

interface ProgressBarProps {
  progress: number;
  success: boolean;
  isMobile?: boolean;
}

const ProgressBar = ({
  progress,
  success = false,
  isMobile = false,
}: ProgressBarProps) => {
  const displayWidth =
    document.documentElement?.clientWidth ||
    document.body?.clientWidth ||
    window.innerWidth;

  const itsAll = success || progress === 100;
  const width = itsAll ? 0 : (displayWidth / 100) * progress;
  const visibility = itsAll ? 'hidden' : 'visible';

  return (
    <ProgressBarContainer $isMobile={isMobile}>
      <ProgressBarComplete $width={width} $visibility={visibility}>
        <Shine />
      </ProgressBarComplete>
    </ProgressBarContainer>
  );
};

const ProgressBarContainer = styled.div<{ $isMobile?: boolean }>`
  position: sticky;
  top: ${({ $isMobile }) =>
    $isMobile
      ? MOBILE_HEADER_OFFSET
      : HEADER_OFFSET_SEARCH}px; //пока есть баннер наверху шапки
  z-index: 999;
  overflow: hidden;
`;

const ProgressBarComplete = styled.div<{
  $width: number;
  $visibility: 'hidden' | 'visible';
}>`
  position: relative;
  height: 3px;
  background-image: linear-gradient(to left, #5bc9f5, #2080f1);
  box-shadow: 0 0 4px 0 #3aa1f2;
  transition: all 0.6s;
  width: ${({ $width }) => $width}px;
  visibility: ${({ $visibility }) => $visibility};
`;

const Shine = styled.div`
  @keyframes shine {
    from {
      left: -50%;
    }
    to {
      left: 100%;
    }
  }

  content: '';
  position: absolute;
  top: 0;
  left: -50%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shine 1.5s infinite;
`;

const mapStateToProps = (state) => ({
  progress: getSearchProgress(state),
  success: isSearchCompleteSelector(state),
});

export default connect(mapStateToProps)(ProgressBar);
